import React from 'react';

import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min';
import '../styles/materialize.css';
// import '../style.css';
// import '../partener-style.css';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

// import Header from '../components/Header/header';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Footer from '../components/Footer/footer';

import {
  getAffiliateDetailByAffiliateKey,
} from '../Actions/actions';

class Root extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoader: false,
      plansDataAffiliateData: [],
    }
  }

  componentDidMount() {
    if (window.location.pathname.split("/")[1] === "signup") {
      if (window.location.pathname.split("/")[2] !== undefined && window.location.pathname.split("/")[2] !== '') {
        this.setState({ isLoader: true });
      }
    }
  }

  componentDidUpdate() {
    const {
      plansDataAffiliate,
    } = this.props.data;
    const {
      plansDataAffiliateData
    } = this.state
    if (plansDataAffiliate && plansDataAffiliate.result) {
      if (plansDataAffiliateData !== plansDataAffiliate) {
        this.setState({
          plansDataAffiliateData: plansDataAffiliate,
          isLoader: false,
        });
      }
    }

  }
  render() {
    // let show ;
    const { pathname } = this.props.location;
    const { isLoader } = this.state;
    const path = pathname.substring(0, 8);
    if (path === '/landing') {
      // show = true;
    }

    const AuthInfo = localStorage.getItem('user');
    let isLogin = false;
    if (AuthInfo !== null) {
      isLogin = true;
    }
    return (
      <div>
        <div id="wrapper">
          {(isLogin) ? (
            <span>

              {this.props.children}
            </span>
          ) : (
              <span>

                {this.props.children}
              </span>
            )}

        </div>
        {isLoader ? "" : (<Footer />)}

      </div>
    );
  }
}
Root.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getAffiliateDetailByAffiliateKey,
  }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Root));
